<ngx-dropzone
  class="ngx-dropzone primary-border"
  *ngIf="!loading"
  ngx-dropzone
  (change)="onSelect($event)"
  [expandable]="true"
  multiple="false"
>
  <ngx-dropzone-label [innerHTML]="dropZoneHtmlElm"></ngx-dropzone-label>
</ngx-dropzone>
<div class="wrapper">
  <ngx-dropzone
    [maxFileSize]="26214400"
    #drop
    [hidden]="true"
    ngx-dropzone
    (change)="onSelect($event)"
    multiple="false"
  ></ngx-dropzone>
  <button *ngIf="!loading" (click)="drop.showFileSelector()" class="k-button">SÉLECTIONNER...</button>
  <p class="italic">Taille limite : 25 Mo</p>
</div>

<div *ngIf="loading" class="panelbar-wrapper" uk-spinner></div>

<div
  *ngIf="errorServer && !loading"
  [@alertDisplay]=""
  class="invalid-feedback-value k-text-center font-size-100"
  role="alert"
>
  <strong>Impossible</strong> d'ajouter le fichier, veuillez réessayer plus tard.
</div>
